<div class="onpist-container">
    <div class="onpist-header">
        <div class="d-flex align-items-center">
            <cmps-icon svgIcon="file-document"></cmps-icon>&nbsp;
            <span>{{ _i18n._7454_KPIS | translate }}</span>
        </div>
    </div>

    <div class="px-3">
        <cmps-wait-status
            class="d-block"
            [class.mb-3]="readonly"
            *ngIf="state?.pending?.reload"
        ></cmps-wait-status>

        <div
            class="mb-3"
            *ngIf="!state?.pending?.reload"
        >
            <div class="d-flex mb-2">
                <ng-container *ngFor="let c of state?.gridColumns">
                    <ng-container [ngSwitch]="c.id">
                        <div
                            *ngSwitchCase="_ColumnID.METRIC"
                            class="onpist-grid-metric-header"
                        >
                            {{ _i18n._9426_ACTIVE_GOALS | translate }}
                        </div>
                        <div
                            *ngSwitchCase="_ColumnID.ACTUAL"
                            class="onpist-grid-other-header"
                        >
                            {{ _i18n._725_ACTUAL | translate }}
                        </div>
                        <div
                            *ngSwitchCase="_ColumnID.TARGET"
                            class="onpist-grid-other-header"
                        >
                            {{ _i18n._726_TARGET | translate }}
                        </div>
                        <div
                            *ngSwitchCase="_ColumnID.PCT_TARGET"
                            class="onpist-grid-other-header"
                        >
                            {{ _i18n._768___TO_TARGET | translate }}
                        </div>
                        <div
                            *ngSwitchCase="_ColumnID.GOAL"
                            class="onpist-grid-other-header"
                        >
                            {{ _i18n._721_GOAL | translate }}
                        </div>
                        <div
                            *ngSwitchCase="_ColumnID.PCT_GOAL"
                            class="onpist-grid-other-header"
                        >
                            {{ _i18n._767___TO_GOAL | translate }}
                        </div>
                        <div
                            *ngSwitchCase="_ColumnID.EXPIRY_DATE"
                            class="onpist-grid-other-header"
                        >
                            {{
                                _i18n._9779_EXPECTED_ACHIEVEMENT_DATE
                                    | translate
                            }}
                        </div>
                    </ng-container>
                </ng-container>
            </div>

            <div
                class="d-flex mb-2"
                *ngFor="let r of state?.activeGoalRows"
            >
                <ng-container *ngFor="let l of r.cells">
                    <ng-container
                        *ngTemplateOutlet="
                            columnsTpl;
                            context: { l: l, canDelete: false }
                        "
                    ></ng-container>
                </ng-container>
            </div>

            <div
                *ngIf="
                    !state?.pending?.reload &&
                    state?.activeGoalRows?.length === 0
                "
                class="onpist-grid-no-metric"
            >
                {{ _i18n._9655_NO_ACTIVE_GOALS | translate }}
            </div>
        </div>

        <div
            class="mb-3"
            *ngIf="!state?.pending?.reload"
        >
            <div class="d-flex mb-2">
                <ng-container *ngFor="let c of state?.gridColumns">
                    <ng-container [ngSwitch]="c.id">
                        <div
                            *ngSwitchCase="_ColumnID.METRIC"
                            class="onpist-grid-metric-header"
                        >
                            {{ _i18n._9654_FOCUS_METRIC | translate }}
                        </div>
                        <div
                            *ngSwitchCase="_ColumnID.ACTUAL"
                            class="onpist-grid-other-header"
                        ></div>
                        <div
                            *ngSwitchCase="_ColumnID.TARGET"
                            class="onpist-grid-other-header"
                        ></div>
                        <div
                            *ngSwitchCase="_ColumnID.PCT_TARGET"
                            class="onpist-grid-other-header"
                        ></div>
                        <div
                            *ngSwitchCase="_ColumnID.GOAL"
                            class="onpist-grid-other-header"
                        ></div>
                        <div
                            *ngSwitchCase="_ColumnID.PCT_GOAL"
                            class="onpist-grid-other-header"
                        ></div>
                        <div
                            *ngSwitchCase="_ColumnID.EXPIRY_DATE"
                            class="onpist-grid-other-header"
                        ></div>
                    </ng-container>
                </ng-container>
            </div>

            <div
                class="d-flex mb-2"
                *ngFor="let r of state?.focusMetricRows"
            >
                <ng-container *ngFor="let l of r.cells">
                    <ng-container
                        *ngTemplateOutlet="
                            columnsTpl;
                            context: { l: l, canDelete: true }
                        "
                    ></ng-container>
                </ng-container>
            </div>

            <div
                *ngIf="
                    !state?.pending?.reload &&
                    state?.focusMetricRows?.length === 0
                "
                class="onpist-grid-no-metric"
            >
                {{ _i18n._9656_NO_FOCUS_METRIC | translate }}
            </div>
        </div>

        <ng-template #noGoalTpl>
            <cmps-icon svgIcon="close-circle"></cmps-icon>
        </ng-template>

        <ng-template
            #columnsTpl
            let-l="l"
            let-canDelete="canDelete"
        >
            <ng-container [ngSwitch]="l.columnId">
                <div
                    *ngSwitchCase="_ColumnID.METRIC"
                    class="onpist-grid-metric"
                    [class.onpist-grid-metric--can-delete]="
                        !readonly && canDelete
                    "
                >
                    <button
                        class="cmps-icon-button--no-bg"
                        cmpsIconButton
                        (click)="_onRemoveMetricClick(l.ctx.metric?.id)"
                        *ngIf="!readonly && canDelete"
                    >
                        <cmps-icon svgIcon="delete"></cmps-icon>
                    </button>
                    {{ l.ctx.metric?.name }}
                </div>
                <div
                    *ngSwitchCase="_ColumnID.ACTUAL"
                    class="onpist-grid-other"
                >
                    {{
                        l.ctx.metricData?.actual == null
                            ? '-'
                            : (l.ctx.metricData.actual | number: '1.0-0')
                    }}
                </div>
                <div
                    *ngSwitchCase="_ColumnID.TARGET"
                    class="onpist-grid-other"
                >
                    {{
                        l.ctx.metricData?.target == null
                            ? '-'
                            : (l.ctx.metricData.target | number: '1.0-0')
                    }}
                </div>
                <div
                    *ngSwitchCase="_ColumnID.PCT_TARGET"
                    class="onpist-grid-other"
                >
                    {{
                        l.ctx.metricData?.percentToTarget == null
                            ? '-'
                            : (l.ctx.metricData.percentToTarget
                              | percent: '1.0-0')
                    }}
                </div>
                <div
                    *ngSwitchCase="_ColumnID.GOAL"
                    class="onpist-grid-other"
                >
                    <ng-container *ngIf="l.ctx.goalData; else noGoalTpl">
                        {{
                            l.ctx.goalData?.goalValue == null
                                ? '-'
                                : (l.ctx.goalData.goalValue | number: '1.0-0')
                        }}
                    </ng-container>
                </div>
                <div
                    *ngSwitchCase="_ColumnID.PCT_GOAL"
                    class="onpist-grid-other"
                >
                    <ng-container *ngIf="l.ctx.goalData; else noGoalTpl">
                        {{
                            l.ctx.goalData?.currentPctGoal == null
                                ? '-'
                                : (1 - l.ctx.goalData.currentPctGoal
                                  | percent: '1.0-0')
                        }}
                    </ng-container>
                </div>
                <div
                    *ngSwitchCase="_ColumnID.EXPIRY_DATE"
                    class="onpist-grid-other"
                >
                    <ng-container *ngIf="l.ctx.goalData; else noGoalTpl">
                        {{
                            l.ctx.goalData?.estimatedCompletionDate == null
                                ? '-'
                                : (l.ctx.goalData.estimatedCompletionDate
                                  | date: 'yyyy-MM-dd')
                        }}
                    </ng-container>
                </div>
            </ng-container>
        </ng-template>

        <div
            class="mb-3 d-flex justify-content-center"
            *ngIf="!readonly"
        >
            <button
                cmpsIconButton
                (click)="_onAddMetricClick()"
            >
                <cmps-icon svgIcon="link"></cmps-icon>
                <span cmpsIconButtonLabel>{{
                    _i18n._9624_ADD_ANOTHER_METRIC | translate
                }}</span>
            </button>
        </div>
    </div>
</div>
